import Vue from 'vue'
import App from './App.vue'

import { icons } from './icons'
import VueGlobalVar from 'vue-global-var'
Vue.use(VueGlobalVar, {
  globals: {
    $icons: icons
  }
})

import vSelectMenu from 'v-selectmenu'
Vue.use(vSelectMenu, { language: 'en' })

Vue.config.productionTip = false
Vue.config.devtools = true

window.onload = function() {
  const elem = document.getElementById('vue-search')
  if (elem) {
    try {
      let config = document.getElementById('app-config-' + elem.dataset.id)
      const vueData = Object.assign({
        el: elem,
        config: JSON.parse(config.innerHTML)
      }, App)
      new Vue(vueData)
    } catch (e) {
      console.log(e)
    }
  }
}